angular.module('impactx.approval').controller('ContractChangeCancelCtrl', ContractChangeCancelCtrl);

ContractChangeCancelCtrl.$inject = ['$scope', '$mdDialog', 'TranslationService'];

function ContractChangeCancelCtrl($scope, $mdDialog, TranslationService) {
    var self = this;

    $scope.trns = {};
    $scope.trns.abort = TranslationService.get('abort');
    $scope.trns.save = self.cancelLabel;

    $scope.cancelReason = JSON.parse(JSON.stringify(self.cancelReason));
    $scope.newComment = "";

    self.cancel = function() {
        $mdDialog.cancel();
    };
    self.answer = function() {
        $mdDialog.hide({
            reason: $scope.cancelReason.selected.id,
            comment: $scope.newComment
        });
    };
}